import randomItem from 'random-item';
import { render } from './util';

class Zone {
	constructor(id, dimensions, contentPath = '') {
		this.id = id;
		this.dimensions = [].concat(dimensions);
		this.contentPath = contentPath;
	}

	/**
	 * @returns {object}
	 */
	getDimensions() {
		return randomItem(this.dimensions);
	}

	/**
	 * @returns {object}
	 */
	getPlaceholder() {
		const { width, height } = this.getDimensions();

		return {
			placeholder: '',
			placeholderSource: '',
			dimensions: { width, height }
		};
	}

	/**
	 * @returns {Promise<object>}
	 */
	async render() {
		const {
			placeholder,
			placeholderSource,
			dimensions
		} = this.getPlaceholder();

		if (this.contentPath === '') {
			return Promise.resolve({
				content: placeholder,
				dimensions: dimensions
			});
		}

		const content = await render(this.contentPath, {
			placeholder,
			placeholderSource,
			dimensions
		});

		return {
			content,
			dimensions
		};
	}
}

export default Zone;
